import React, { useState } from "react";
import "./style.css";
import { Button } from "react-bootstrap";
import SkipNextOutlinedIcon from "@mui/icons-material/SkipNextOutlined";
import SkipPreviousOutlinedIcon from "@mui/icons-material/SkipPreviousOutlined";
const AnnouncementPopup = ({ message, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    localStorage.setItem("isShown", true);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % message.length);
  };
  console.log("Currentindex", currentIndex);
  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? message.length - 1 : prevIndex - 1
    );
  };

  if (message.length > 0) {
    return (
      <div className="popup">
        <div className="popup-inner">
          <h2 className="title">Announcement</h2>

          <div>
            <h6
              style={{
                textAlign: "left",
                margin: "20px 0px 20px 0px",
                fontWeight: "800",
              }}
            >
              {message[currentIndex].title}
            </h6>
            <p style={{ textAlign: "left" }}>
              {message[currentIndex].description}
            </p>
            {message[currentIndex].image && (
              <img
                src={message[currentIndex].image}
                className="mt-3"
                alt=""
                style={{ width: "100%" }}
              />
            )}
          </div>

          {/* <br />
          <br /> */}
          <div style={{ margin: "10px 0 10px 0" }}>
            <Button
              className="previous-btn mt-2"
              onClick={handlePrevious}
              hidden={currentIndex == 0}
              style={{ marginRight: "1em" }}
            >
              <SkipPreviousOutlinedIcon />
              &nbsp;Previous{" "}
            </Button>
            <Button
              className="next-btn"
              onClick={handleNext}
              hidden={currentIndex == message.length - 1}
            >
              Next &nbsp;
              <SkipNextOutlinedIcon />
            </Button>
          </div>
          {currentIndex == message.length - 1 || message.length == 1 ? (
            <div>
              <Button className="close-btn" onClick={onClose}>
                OK
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
  // return (
  //   <div className="popup">
  //     <div className="popup-inner">
  //       <h2 className="title">Announcement</h2>

  //       <div>
  //         <h6
  //           style={{
  //             textAlign: "left",
  //             margin: "20px 0px 20px 0px",
  //             fontWeight: "800",
  //           }}
  //         >
  //           {message[currentIndex].title}
  //         </h6>
  //         <p style={{ textAlign: "left" }}>
  //           {message[currentIndex].description}
  //         </p>
  //         {message[currentIndex].image && (
  //           <img
  //             src={message[currentIndex].image}
  //             className="mt-3"
  //             alt=""
  //             style={{ width: "100%" }}
  //           />
  //         )}
  //       </div>

  //       {/* <br />
  //       <br /> */}
  //       <div style={{ margin: "10px 0 10px 0" }}>
  //         <Button
  //           className="previous-btn mt-2"
  //           onClick={handlePrevious}
  //           hidden={currentIndex == 0}
  //           style={{ marginRight: "1em" }}
  //         >
  //           <SkipPreviousOutlinedIcon />
  //           &nbsp;Previous{" "}
  //         </Button>
  //         <Button
  //           className="next-btn"
  //           onClick={handleNext}
  //           hidden={currentIndex == message.length - 1}
  //         >
  //           Next &nbsp;
  //           <SkipNextOutlinedIcon />
  //         </Button>
  //       </div>
  //       {currentIndex == message.length - 1 || message.length == 1 ? (
  //         <div>
  //           <Button className="close-btn" onClick={onClose}>
  //             OK
  //           </Button>
  //         </div>
  //       ) : (
  //         ""
  //       )}
  //     </div>
  //   </div>
  // );
};

export default AnnouncementPopup;
